import type { ChatViewModel } from "./store.js";

const notificationPreferenceStorageKey = "tg_client_notifications_enabled";

const supportsNotifications = (): boolean =>
  typeof window !== "undefined" && "Notification" in window;

const supportsStorage = (): boolean => typeof window !== "undefined" && "localStorage" in window;

export const getNotificationPermission = (): NotificationPermission | "unsupported" =>
  supportsNotifications() ? Notification.permission : "unsupported";

export const getNotificationEnabled = (): boolean => {
  if (!supportsStorage()) {
    return true;
  }

  const stored = window.localStorage.getItem(notificationPreferenceStorageKey);
  return stored !== "0";
};

export const setNotificationEnabled = (enabled: boolean): void => {
  if (!supportsStorage()) {
    return;
  }

  window.localStorage.setItem(notificationPreferenceStorageKey, enabled ? "1" : "0");
};

export const requestNotificationPermission = async (): Promise<
  NotificationPermission | "unsupported"
> => {
  if (!supportsNotifications()) {
    return "unsupported";
  }

  return Notification.requestPermission();
};

// Системное уведомление не про чат (например, «ИИ-пуш папки завершён»).
// tag склеивает дубли: событие приходит в каждую открытую вкладку, а
// браузер с одинаковым tag показывает одно уведомление.
export const showSystemNotification = (title: string, body: string, tag?: string): void => {
  if (!supportsNotifications() || Notification.permission !== "granted") {
    return;
  }
  const notification = new Notification(title, { body, ...(tag ? { tag } : {}) });
  notification.onclick = () => {
    window.focus();
    notification.close();
  };
  window.setTimeout(() => notification.close(), 12_000);
};

export const showIncomingMessageNotification = (params: {
  chat: ChatViewModel;
  body: string;
  onClick?: () => void;
}): Notification | null => {
  if (!supportsNotifications() || Notification.permission !== "granted") {
    return null;
  }

  const notification = new Notification(params.chat.title, {
    body: params.body,
    ...(params.chat.avatarUrl ? { icon: params.chat.avatarUrl } : {})
  });

  if (params.onClick) {
    notification.onclick = () => {
      params.onClick?.();
      notification.close();
    };
  }

  window.setTimeout(() => {
    notification.close();
  }, 9_000);

  return notification;
};
